import { DatePicker, Form, Input, Select } from "antd";
import PropTypes from "prop-types";

const InsuranceCustomerFormFields = ({
    t,
    provider,
    states,
    statesLoading,
    showBonzahFields,
    gridClassName = "grid grid-cols-1 gap-x-4 md:grid-cols-2",
}) => {
    const isBonzah = showBonzahFields ?? String(provider).toLowerCase() === "bonzah";

    const stateOptions = states.map((state) => ({
        value: state.isoCode,
        label: state.name,
    }));

    return (
        <div className={gridClassName}>
            <Form.Item
                label={t("wizard.firstName")}
                name="firstName"
                rules={[{ required: true, message: t("wizard.fieldRequired") }]}>
                <Input />
            </Form.Item>

            <Form.Item
                label={t("wizard.lastName")}
                name="lastName"
                rules={[{ required: true, message: t("wizard.fieldRequired") }]}>
                <Input />
            </Form.Item>

            <Form.Item
                label={t("wizard.email")}
                name="email"
                rules={[
                    { required: true, message: t("wizard.fieldRequired") },
                    { type: "email", message: t("wizard.invalidEmail") },
                ]}>
                <Input />
            </Form.Item>

            <Form.Item
                label={t("wizard.phone")}
                name="phone"
                rules={[{ required: true, message: t("wizard.fieldRequired") }]}>
                <Input />
            </Form.Item>

            <Form.Item
                label={t("wizard.dateOfBirth")}
                name="dateOfBirth"
                rules={[{ required: true, message: t("wizard.fieldRequired") }]}>
                <DatePicker className="w-full" format="YYYY-MM-DD" />
            </Form.Item>

            <Form.Item
                label={t("wizard.licenseNumber")}
                name="licenseNumber"
                rules={[{ required: true, message: t("wizard.fieldRequired") }]}>
                <Input />
            </Form.Item>

            <Form.Item
                label={t("wizard.licenseState")}
                name="licenseState"
                rules={[{ required: true, message: t("wizard.fieldRequired") }]}>
                <Select
                    showSearch
                    loading={statesLoading}
                    placeholder={t("wizard.licenseState")}
                    optionFilterProp="label"
                    options={stateOptions}
                />
            </Form.Item>

            <Form.Item
                label={t("wizard.licenseExpiration")}
                name="licenseExpiration"
                rules={[{ required: true, message: t("wizard.fieldRequired") }]}>
                <DatePicker className="w-full" format="YYYY-MM-DD" />
            </Form.Item>

            {isBonzah ? (
                <>
                    <Form.Item
                        label={t("wizard.addressLine1")}
                        name="addressLine1"
                        rules={[{ required: true, message: t("wizard.fieldRequired") }]}>
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label={t("wizard.zipCode")}
                        name="zipCode"
                        rules={[{ required: true, message: t("wizard.fieldRequired") }]}>
                        <Input />
                    </Form.Item>
                </>
            ) : null}
        </div>
    );
};

InsuranceCustomerFormFields.propTypes = {
    t: PropTypes.func.isRequired,
    provider: PropTypes.string,
    states: PropTypes.arrayOf(PropTypes.object).isRequired,
    statesLoading: PropTypes.bool,
    showBonzahFields: PropTypes.bool,
    gridClassName: PropTypes.string,
};

InsuranceCustomerFormFields.defaultProps = {
    provider: undefined,
    statesLoading: false,
    showBonzahFields: undefined,
    gridClassName: "grid grid-cols-1 gap-x-4 md:grid-cols-2",
};

export default InsuranceCustomerFormFields;
